import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/8e779552-dd3a-4726-a8af-dabb592c9090";
export const REGISTER_URL = "https://a.ntrk2.com/d7e4a792-1f57-435a-a9ca-9f231ac685e2";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://hi268.loadprkw2a.com/download?openExternalBrowser=1&id=lhexhws4bj6fb6x";

export * from "./codes";
export * from "./context";
